module.exports = __webpack_public_path__ + "img/comptable.9f1499cd.png";